import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const FETCH_TOP_PERFORMING_GOAL = "saga/FETCH_TOP_PERFORMING_GOAL";
export const FETCH_TOP_PERFORMING_GOAL_SUCCESS = "saga/FETCH_TOP_PERFORMING_GOAL_SUCCESS";
export const FETCH_TOP_PERFORMING_GOAL_FAILURE = "saga/FETCH_TOP_PERFORMING_GOAL_FAILURE";
export const FETCH_LEAST_PERFORMING_GOAL = "saga/FETCH_LEAST_PERFORMING_GOAL";
export const FETCH_LEAST_PERFORMING_GOAL_SUCCESS = "saga/FETCH_LEAST_PERFORMING_GOAL_SUCCESS";
export const FETCH_LEAST_PERFORMING_GOAL_FAILURE = "saga/FETCH_LEAST_PERFORMING_GOAL_FAILURE";
export const FETCH_GOALS_TO_WATCH = "saga/FETCH_GOALS_TO_WATCH";
export const FETCH_GOALS_TO_WATCH_SUCCESS = "saga/FETCH_GOALS_TO_WATCH_SUCCESS";
export const FETCH_GOALS_TO_WATCH_FAILURE = "saga/FETCH_GOALS_TO_WATCH_FAILURE";
export const SET_GOALS_TO_WATCH = "saga/FETCH_GOALS_TO_WATCH";
export const FETCH_GOALS = "saga/FETCH_GOALS";
export const FETCH_GOALS_SUCCESS = "saga/FETCH_GOALS_SUCCESS";
export const FETCH_GOALS_FAILURE = "saga/FETCH_GOALS_FAILURE";
export const FETCH_GOALS_BY_DATE = "saga/FETCH_GOALS_BY_DATE";
export const FETCH_GOALS_BY_DATE_SUCCESS = "saga/FETCH_GOALS_BY_DATE_SUCCESS";
export const FETCH_GOALS_BY_DATE_FAILURE = "saga/FETCH_GOALS_BY_DATE_FAILURE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  fetchGoalsByDate: createAction(FETCH_GOALS_BY_DATE),
  setGoalsToWatch: createAction(SET_GOALS_TO_WATCH)
};
export default function* watchGoals() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(SET_GOALS_TO_WATCH, setGoalsToWatch);
  yield takeLatest(FETCH_GOALS_BY_DATE, fetchGoalsByDate);
}

let date;

export function* getCurrentUserData(data) {
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.user });
  yield put({ type: SET_LOADING, payload: true });

  date = data.payload.date || (yield select(state => state.goalsSummary.currentUser.calendarEndDate));

  const id = yield select(state => state.goalsSummary.currentUser.organization_id);
  const objectId = yield select(state => state.goalsSummary.currentUser.current_object_id);
  const locationId = yield select(state => state.goalsSummary.currentUser.current_location_id);
  const regionId = yield select(state => state.goalsSummary.currentUser.current_region_id);

  const allSagas = [
    fetchTopPerformingGoal(id, objectId, locationId, regionId, date),
    fetchLeastPerformingGoal(id, objectId, locationId, regionId, date),
    fetchGoalsToWatch(id, objectId, locationId, regionId, date),
    fetchGoals(id, objectId, locationId, regionId, date)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchTopPerformingGoal(id, objectId, locationId, regionId, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals/top_performing" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&limit=1"
    );
    yield put({ type: FETCH_TOP_PERFORMING_GOAL_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TOP_PERFORMING_GOAL_FAILURE, error });
  }
}

export function* fetchLeastPerformingGoal(id, objectId, locationId, regionId, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals/least_performing" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&limit=1"
    );
    yield put({ type: FETCH_LEAST_PERFORMING_GOAL_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_LEAST_PERFORMING_GOAL_FAILURE, error });
  }
}

export function* fetchGoalsToWatch(id, objectId, locationId, regionId, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals/goals_to_watch" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_GOALS_TO_WATCH_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_TO_WATCH_FAILURE, error });
  }
}

export function* setGoalsToWatch(data) {
  try {
    const response = yield call(axios.put, queryParams.apiVersion + "goals/set_goals_to_watch", {
      default_goal_ids: data.payload.data
    });
    yield put({ type: FETCH_GOALS_TO_WATCH_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_TO_WATCH_FAILURE, error });
  }
}

export function* fetchGoals(id, objectId, locationId, regionId, date) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_GOALS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_FAILURE, error });
  }
}

export function* fetchGoalsByDate(payload) {
  yield put({ type: SET_LOADING, payload: true });
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals" +
        "?organization_id=" +
        payload.payload.id +
        "&location_id=" +
        payload.payload.locationId +
        "&region_id=" +
        payload.payload.regionId +
        "&object_id=" +
        payload.payload.objectId +
        "&date=" +
        payload.payload.date
    );
    yield put({ type: FETCH_GOALS_BY_DATE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_BY_DATE_FAILURE, error });
  }
}
